


































import axios from 'axios';
import { LanguageObject } from '@/i18n';
import DashboardUtils, { DashboardTile } from '@/utils/DashboardUtils';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
import mixins from 'vue-typed-mixins';
import { Survey, SurveyParticipation } from '@/utils/SurveyUtils';
import TileUtils, {
  TileAPIParams,
  TileSurveyProgressResponse,
} from '@/utils/TileUtils';
import { colorGradient, hexToRgb, rgbToHex } from '@/utils/ChartUtils';

export default mixins().extend({
  props: {
    tile: {
      type: Object as () => DashboardTile,
    },

    params: {
      type: Object as () => TileAPIParams,
    },
  },

  computed: {
    suborganizationTitle(): string {
      return (
        this.$translate(this.params?.survey?.languageobjects?.suborg) ||
        this.$tc('model.survey.suborg')
      );
    },
  },

  data(): {
    data?: TileSurveyProgressResponse;
  } {
    return {
      data: undefined,
    };
  },

  mounted() {
    this.load();
  },

  watch: {
    params(current, previous) {
      if (
        current.survey !== previous.survey ||
        current.surveyparticipation !== previous.surveyparticipation
      ) {
        this.load();
      }
    },
  },

  methods: {
    async load() {
      try {
        this.data = undefined;
        this.$alert.hide('load');
        this.data = await TileUtils.submissionstatus(this.params);
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    gradient(progress: number) {
      return colorGradient(
        (progress || 0) / 100,
        hexToRgb(this.$vuetify.theme.themes.light.primary as string),
        hexToRgb(this.$vuetify.theme.themes.light.success as string)
      );
    },
  },
});
